// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { compose, fromPairs, keys, map, pick, toPairs } from "ramda"

export const mapDrawerData = (fields: any, rowData: any, translations) => {
  const mapped = map(([key, value]) => [
    i18n(fields[key].key),
    {
      asHTML: fields[key].asHTML || false,
      expandable: !!value ? fields[key].expandable : false,
      notBold: !!value ? fields[key].notBold : false,
      value: fields[key].transform ? fields[key].transform(value, rowData) : value || "-",
    },
  ])

  const result = compose(
    fromPairs,
    // @ts-ignore
    mapped,
    toPairs,
    // @ts-ignore
  )(pick(keys(fields), rowData))

  return result
}
